module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8555/img/InterstitialBlobs.png"